export default function CameraPictureIcon(props) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill={props.fill || "#6CB6E3"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.5 8C4.5 6.06563 6.06563 4.5 8 4.5C9.93437 4.5 11.5 6.06563 11.5 8C11.5 9.93437 9.93437 11.5 8 11.5C6.06563 11.5 4.5 9.93437 4.5 8ZM8 6C6.89687 6 6 6.89687 6 8C6 9.10312 6.89687 10 8 10C9.10312 10 10 9.10312 10 8C10 6.89687 9.10312 6 8 6ZM11.3406 1.02562L11.6656 2H14C15.1031 2 16 2.89687 16 4V12C16 13.1031 15.1031 14 14 14H2C0.895313 14 0 13.1031 0 12V4C0 2.89687 0.895313 2 2 2H4.33437L4.65938 1.02562C4.8625 0.413125 5.43438 0 6.08125 0H9.91875C10.5656 0 11.1375 0.413125 11.3406 1.02562ZM2 3.5C1.72375 3.5 1.5 3.725 1.5 4V12C1.5 12.275 1.72375 12.5 2 12.5H14C14.275 12.5 14.5 12.275 14.5 12V4C14.5 3.725 14.275 3.5 14 3.5H10.5844L9.91875 1.5H6.08125L5.41563 3.5H2Z" />
    </svg>
  )
}
